import * as React from 'react'
import { css } from 'styled-components/macro'
import { FormattedMessage } from 'react-intl'
import { Icon } from '@/materials/index'

function InfoBox() {
  const [isOpen, setIsOpen] = React.useState(false)
  return (
    <div css={styles.root as any}>
      <h4 css={styles.header as any}>
        <FormattedMessage id="infobox.title" defaultMessage="Wie unsere Hochrechnungen entstehen" />
      </h4>
      {isOpen && (
        <div css={styles.content as any}>
          <p>
            <FormattedMessage
              id="infoBox.content1"
              defaultMessage="Die Hochrechnung macht bereits früh am Sonntagnachmittag präzise Vorhersagen über den Anteil Ja-Stimmen für
                eidgenössische Vorlagen. Das Modell generiert Hochrechnungen für den Ja-Stimmen Anteil, sowie die
                Standesstimmen. Das Datenteam von LeeWas hat das statistische Modell mit verschiedenen Werkzeugen des
                maschinellen Lernens entwickelt (künstliche Intelligenz)."
            />
          </p>
          <p>
            <FormattedMessage
              id="infoBox.content2"
              defaultMessage="Als Basis dienen die Abstimmungsdaten auf Gemeindeebene aller Abstimmungen der letzten 10 Jahre. Der
                Algorithmus lernt am Abstimmungssonntag fortlaufend wie die aktuelle Vorlage optimal, als Funktion aller
                vergangenen Abstimmungen, berechnet werden kann. Mit jedem neuen Gemeinderesultat generiert der Algorithmus
                ein neues Modell und eine neue Hochrechnung."
            />
          </p>
          <p>
            <FormattedMessage
              id="infoBox.content3"
              defaultMessage="Die Schätzungen werden fortlaufend erneuert und in Echtzeit visualisiert. Im Verlauf des Abstimmungssonntags
                werden die Hochrechnungen besser und die statistischen Unsicherheiten nehmen ab. Bereits mit der Auszählung
                10% aller Schweizer Gemeinden kann eine gute erste Hochrechnung vorgenommen werden: Simulationen zeigen,
                dass die maximale Abweichung über 62 Vorlagen bei ±4% liegt."
            />
          </p>
        </div>
      )}
      <button
        css={styles.button as any}
        onClick={() => {
          setIsOpen((_isOpen) => !_isOpen)
        }}
      >
        {isOpen ? <Icon name="ArrowTop18" /> : <Icon name="ArrowBottom18" />}
        <span css={styles.buttonLabel as any}>
          {isOpen ? (
            <FormattedMessage id="infoBox.hide" defaultMessage="Infos ausblenden" />
          ) : (
            <FormattedMessage id="infoBox.show" defaultMessage="Infos einblenden" />
          )}
        </span>
      </button>
    </div>
  )
}

const styles = {
  root: css`
    font-family: var(--font-sans-serif);
    background-color: var(--color-brandblue-main);
    border-top: solid var(--color-yellow-main) 5px;
    padding-inline: 30px;
    padding-block: 30px;
    /* width: 436px; */
  `,
  header: css`
    margin: 0;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
  `,
  button: css`
    background-color: transparent;
    cursor: pointer;
    padding: 0;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: var(--color-yellow-main);
  `,
  buttonLabel: css`
    margin-left: 10px;
    line-height: 18px;
  `,
  icon: css`
    height: 30px;
    width: 30px;
  `,
  content: css`
    font-size: 16px;
    line-height: 23px;
    color: #ffffff;
  `,
}

export default InfoBox
